<template lang='pug'>
div
  v-card-title
    v-toolbar-title.subheading(style="color: grey; margin-top: 15px; margin-right: 25px") Custom Filter :&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      span.pr-2
    v-text-field(
      v-model="search",
      append-icon="mdi-magnify",
      placeholder="Masukan No IP",
      style="margin-top:-10px",
      @click:append="handleSearch",
      @keyup.enter="handleSearch",
      single-line,
      hide-details
    )
      span.pr-2
    v-checkbox(
      v-model="isLampiran",
      label="Lampiran Pengawalan"
    )
  ModalErrorNotif(:openModalNotif="openModalNotif" @closeModal="openModalNotif = false" :errorNotif="errorNotif")
  ModalListEmailLogs(ref="openEmailLogs" :dataIpNo="dataIpNo" :actionFor="actionFor")
  ModalNotificationLogs(ref="openNotificationLogs" :dataIpNo="dataIpNo" :actionFor="actionFor")
  v-data-table.elevation-1(
    :headers="ip.headers",
    :must-sort="true",
    :sort-by="pagination.sortBy",
    :sort-desc="pagination.descending",
    :items="ip.items",
    :single-expand="true",
    :expanded.sync="expanded",
    item-key="ipNo",
    :show-expand="ip.items[0] && ip.items[0].ipForm == 'BIB-HSE-PPO-F-012-02' ? false : true ",
    )
    template(v-slot:item.ipNo="{ item }")
      div(v-if="isExtendWaskat(item)" class="div-extend" v-html="item.ipNo+'<hr class=\"hr-extend\"><span class=\"deep-orange--text\">Perpanjangan</span>'")
      div(v-else) {{ item.ipNo }}
    template(v-slot:item.ipDateFormat="{ item }")
      div(v-if="isExtendWaskat(item)" class="div-extend" v-html="item.ipDateFormat+'<hr class=\"hr-extend\"><span class=\"deep-orange--text\">'+item.ipExtendDateFormat+'</span>'")
      div(v-else) {{ item.ipDateFormat }}
    template(v-slot:item.ipStatusLabel="{ item }")
      v-chip(
        label,
        small,
        :color="config.status[item.ipStatusColor].color",
        style="width: 100%; justify-content: space-evenly",
        text-color="black"
      ) {{ item.ipStatusLabel }}
      hr(v-if="isExtendWaskat(item)" class="hr-extend")
      v-chip(
        v-if="isExtendWaskat(item)"
        label,
        small,
        :color="config.status[item.ipExtendStatusColor].color",
        style="width: 100%; justify-content: space-evenly",
        text-color="black"
      ) {{ item.ipExtendStatusLabel }}
    template(v-slot:item.actions="{ item }")
      div
        v-icon.mr-2(
          v-if="[2, 10].includes(item.ipStatus)",
          small,
          color="red",
          dark,
          @click="openModal(item)"
        ) redo
        v-tooltip(top)
          template(v-slot:activator="{ on, attrs }")
            v-icon.mr-2(
              small,
              color="orange",
              dark,
              @click="openModalEmailLogs(item)"
              v-bind="attrs"
              v-on="on"
            ) mdi-email-multiple-outline
          span Email logs pengajuan
        v-tooltip(top)
          template(v-slot:activator="{ on, attrs }")
            v-icon.mr-2(
              small,
              color="blue",
              dark,
              @click="openModalNotificationLogs(item)"
              v-bind="attrs"
              v-on="on"
            ) mdi-bell-outline
          span Notification logs pengajuan
        ResendPopUp(
          v-if="dialog",
          :ip="dataNotif",
          :dialogOpen="dialog",
          @interface="closeModal()"
        )
        v-tooltip(top, v-if="item.ipStatus==2")
          template(v-slot:activator="{ on, attrs }")
            v-icon.mr-2(
              small,
              color="red",
              dark,
              @click="openModalReject(item)"
              v-bind="attrs"
              v-on="on"
            ) mdi-close-circle
          span Reject
      hr(v-if="'ipExtendStatus' in item" class="my-2")
      div(v-if="'ipExtendStatus' in item")
        v-icon.mr-2(
          v-if="[2,10].includes(item.ipExtendStatus)",
          small,
          color="red",
          dark,
          @click="openModal(item)"
        ) redo
        v-tooltip(top)
          template(v-slot:activator="{ on, attrs }")
            v-icon.mr-2(
              small,
              color="orange",
              dark,
              @click="openModalEmailLogs(item, 'extendWaskat')"
              v-bind="attrs"
              v-on="on"
            ) mdi-email-multiple-outline
          span Email logs perpanjangan
        v-tooltip(top)
          template(v-slot:activator="{ on, attrs }")
            v-icon.mr-2(
              small,
              color="blue",
              dark,
              @click="openModalNotificationLogs(item)"
              v-bind="attrs"
              v-on="on"
            ) mdi-bell-outline
          span Notification logs pengajuan
        ResendPopUp(
          v-if="dialog",
          :ip="dataNotif",
          :dialogOpen="dialog",
          @interface="closeModal()"
        )
    template(v-slot:expanded-item="{ headers, item }" )
      td(:colspan="headers.length")
        
        TimelinePermitListAdmin(
          :item="item"
          :config="config"
          :getWITADate="getWITADate"
          :timelineDetail="timelineDetail"
          :getNameApproverKTT="getNameApproverKTT"
          :getTitleApprover="getTitleApprover"
          :isExtendWaskat="isExtendWaskat"
        )

        
  v-dialog(v-model="rejectDialog" persistent max-width="500px")
    v-card()
        v-card-title(class="headline grey lighten-2") Reject Form
        v-card-text
            v-layout(wrap)
                v-flex(xs12 mt-4)
                    v-textarea(
                        v-model="rejectComment"
                        filled
                        label="Reasons for Rejection"
                        value=""
                    )
        v-card-actions
            v-spacer
            v-btn(text @click.native="rejectDialog = false") Close
            v-btn(:disabled="rejectComment==null || rejectComment.trim()==''" text :loading="rejectDialog2" color="blue darken-1" @click="rejectDialog2 = true") Submit
            v-dialog(
                v-model="rejectDialog2"
                hide-overlay
                persistent
                width="300")
                v-card(color="primary" dark)
                v-card-text Processing. Please wait!
                    v-progress-linear(indeterminate color="white" class="mb-0")
</template>

<script>
import * as config from "../config/index.json";
import helper from "../helper/index.js";
import axios from "axios";
import { mapState } from "vuex";
import ResendPopUp from "@/components/ResendPopUp.vue";
import ModalErrorNotif from "../components/ModalErrorNotif.vue";
import ModalListEmailLogs from "../components/ModalListEmailLogs.vue";
import ModalNotificationLogs from "../components/ModalNotificationLogs.vue";
import ModalListApprover from "../components/modal/ListApprover.vue";
import TimelinePermitListAdmin from "@/components/TimelinePermitListAdmin.vue";
export default {
  name: "AdminEditIM",
  components: {
    ResendPopUp,
    ModalErrorNotif,
    ModalListEmailLogs,
    ModalNotificationLogs,
    ModalListApprover,
    TimelinePermitListAdmin
  },
  props: {
    title: String,
    keyword: String,
  },
  data() {
    return {
      search: "",
      expanded: [],
      isLampiran:false,
      dataNotif: {},
      dialog: false,
      openModalNotif : false,
      dataIpNo : '',
      errorNotif :'',
      formName: config.FormName,
      config: config.default,
      ip: {
        headers: [
          {
            text: 'Nomor IP',
            align: 'start',
            sortable: false,
            value: 'ipNo',
          },
          { text: 'Tanggal', value: 'ipDateFormat' },
          { text: 'Status', value: 'ipStatusLabel', align: 'center', width: '120px'},
          { text: 'Action', value: 'actions' },
          { text: '', value: 'data-table-expand' }
        ],
        items: []
      }, 
      pagination: {
        sortBy: ["ipNo"],
        descending: [true],
      },
      uploadBukti: false,
      docPelaporan: null,
      actionFor: null,
      reject: null,
      rejectComment: null,
      rejectDialog: false,
      rejectDialog2: false,
    };
  },
  mounted() {
    this.search = this.keyword;
  },
  computed: {
    ...mapState(["dataUsers", "API_URL"]),
  },
  methods: {
    isExtendWaskat: (i) => {
      if (i && 'ipExtendStatus' in i) {
        return true
      }
      return false;
    },
    getWITADate: helper.getWITADate,
    formatDate:helper.formatDate,
    openModal(input) {
      this.dataNotif = input;
      this.dialog = true;
    },
    openModalEmailLogs(val, actionFor = null){
      this.$refs.openEmailLogs.dialog = true
      this.dataIpNo = val.ipNo
      this.actionFor = actionFor
    },
    openModalReject(val){
      this.reject = val
      this.rejectDialog = true
    },
    openModalNotificationLogs(val, actionFor = null){
      this.$refs.openNotificationLogs.dialog = true
      this.dataIpNo = val.ipNo
      this.actionFor = actionFor
    },
    closeModal: function () {
      this.dialog = false;
      this.dataNotif = {};
    },
    handleSearch(){
      const data = {
        ipNo : this.search,
        isLampiran : this.isLampiran
      }
      if(this.search){
        const config = {
        method: "post",
        url: `${this.API_URL}/v1/requests/admin/searchPermit`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.token}`,
        },
        data: data,
      };
      axios(config).then((res) => {
        // console.log(res.data.data)
        this.ip.items = res.data.data
        if(this.ip.items){
          for (let i = 0; i < this.ip.items.length; i++) {
            this.ip.items[i].ipStatusLabel = this.config.status[this.ip.items[i].ipStatus].name;
            this.ip.items[i].ipStatusColor = this.ip.items[i].ipStatus;
            this.ip.items[i].ipDateFormat = this.formatDate(this.ip.items[i].ipDate);
            this.ip.items[i].ipFormShortName = this.config.ShortenFormName[this.ip.items[i].ipForm];

            // for extend waskat
            if (this.ip.items[i].ipExtendStatus) {
              this.ip.items[i].ipExtendStatusLabel = this.config.status[this.ip.items[i].ipExtendStatus].name;
              this.ip.items[i].ipExtendStatusColor = this.ip.items[i].ipExtendStatus;
              this.ip.items[i].ipExtendDateFormat = this.formatDate(this.ip.items[i].ipExtendDate);
              this.ip.items[i].ipExtendFormShortName = this.config.ShortenFormName[this.ip.items[i].ipForm];
            }
          }
        }
      }).catch((err) => {
        console.log(err.response)
        this.openModalNotif = true
        this.errorNotif = "Ip No Required"
      })
      }else{
        this.openModalNotif = true
        this.errorNotif = "Ip No Required"
      }

    },
    timelineDetail(postAs, index, formCode = "") {
      switch (postAs) {
        case "deptHead":
          if (formCode == "BIB-HSE-PPO-IZIN-TAMU") return "DIC / PJO";
          else if (
            formCode == "BIB-HSE-PPO-FRM-018-03" ||
            formCode == "BIB-HSE-PPO-F-071-01" ||
            formCode == "BIB-HSE-PPO-F-071-02"
          )
            return "DIC / Kustodian";
          return "Dept. Head / Cust Dept.head";
        case "divHead":
          return "Div.Head / Cust Div.head";
        case "custodianDeptHead":
          return "Custodian Dept Head";
        case "custodianDivHead":
          return "Custodian Div Head";
        case "ohsDeptHead":
          if (
            formCode == "BIB-HSE-PPO-F-071-01" ||
            formCode == "BIB-HSE-PPO-F-071-02"
          )
            return "OHS Dept Head (PNC)";
          return "OHS Dept Head";
        case "hseDivHead":
          return "HSE Div Head";
        case "approver":
          return formCode == "BIB-HSE-PPO-IZIN-TAMU" ? "KTT / HSE Head" : "KTT";
        case "teamLeader":
          return "Team Leader / Custodian Dept Head / Sec Head";
        case "pjo":
        case "secHead":
          return "Atasan / PJO / Section Head";
        case "karyawan":
          return "Pekerja";
        case "waskat":
          return `Waskat ${index + 1}`;
        case "atasan":
          return `Atasan / PJO / Section Head`;
        case "safetyInternal": 
          return "Safety Internal";
          case "requestor":
          return "PJO";
        case "verificator1": 
          return "DIC/Custodian";
        case "verificator2": 
          return "OHS Dept Head (PNC)";
        case "safetyMitra": 
          return "Safety Mitra Kerja";
        default:
          return "approverDefault";
      }
    },

    getNameApproverKTT(item) {
        return helper.getKTTApproverName(item)
    },
    getTitleApprover(item) {
        if ( item.matrix.includes('KTT') ) {
            return 'Kepala Teknik Tambang'
        } else {
            return item.title ?? item.position
        }
    }
  },
  watch: {
    rejectDialog2 (val) {
      if (!val) return
      const formData = new FormData();
      formData.append('_id', this.reject._id);
      formData.append('status', 8);
      formData.append('comment', this.rejectComment.trim());
      formData.append('approvalUser', JSON.stringify(this.dataUsers));
      const config = {
          method: "put",
          url: `${this.API_URL}/v1/requests/rejectByAdmin`,
          headers: {"Authorization": `Bearer ${this.$store.state.token}`},
          data: formData
      };
      axios(config).then(res => {
          if (res.status == 200) {
              setTimeout(() => {
                  this.rejectDialog2 = false;
                  this.rejectDialog = false;
                  location.reload();
              },
              1000);
          }
      });
    }
  }
};
</script>

<style>
.pointer {
  cursor: pointer;
}
.div-extend {
  padding: 16px 0;
}
.hr-extend {
  margin: 7px 0;
  background-color: #cbcbcb;
  height: 1px;
  border: 0;
}
</style>